const Title = ({data}) => {
    let title = data?.title?.rendered || "";
    let subtitle = data?.acf?.sub_title || "";
    let slug = data?.slug ? data.slug + '-nav' : '';

    return ( 
        <div className="title fadeInScroll" id={slug}>
            <h2>
                <span className="fa-regular fa-eye fs1" aria-hidden="true"></span>
                <span>{title}</span>
            </h2>
            {subtitle ? <div><span className="head-line"></span><p>{subtitle}</p></div> : ''}
        </div>
    );
}
 
export default Title;